<div>
  <div class="float-actions-wrapper" #actionsContainer *ngIf="showActionsBar">

    <button mat-icon-button color="primary"
      class="float-btn" (click)="isActive = !isActive">
      <mat-icon *ngIf="!isActive">settings</mat-icon>
      <mat-icon *ngIf="isActive">close</mat-icon>
    </button>

    <div class="footer-actions" [class.active]="isActive">
      <p class="orange-color mb-3 font-14" *ngIf="actionsPermissions.currentRestaurantAction?.attendancefeature">
        {{"auth.Clock-In" | translate}}: <span class="fontSemiBold">{{actionsPermissions.currentRestaurantAction?.lastClockIn | date:'d MMM, y - h:mm a'}}</span>
      </p>
      <div class="">
        <button mat-stroked-button *ngIf="actionsPermissions.canPrintTill"
          class="btn-light mb-2 w-100"
          [disabled]="actionLoader"
          [class.loading]="actionLoader == 'printTill'"
          (click)="openTillAmount()">
          {{'auth.Print Till' | translate}}
        </button>
        <button mat-stroked-button
          class="btn-orange mb-2 w-100"
          [disabled]="actionLoader"
          [class.loading]="actionLoader == 'clockout'"
          (click)="clockout()"
          *ngIf="
            actionsPermissions.currentRestaurantAction.requiredaction == requiredaction.ClockOut
            && actionsPermissions.currentRestaurantAction.attendancefeature
          ">{{'auth.Clock-Out' | translate}}</button>
      </div>
    </div>

  </div>
</div>
